<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix" style="margin-bottom: 0 !important;">
      <vxe-radio-group v-model="selectTab" @change="changeTab">
        <ul class="tab-list" style="display: flex;align-items: center">
          <li>
            <vxe-radio name="xtabs" label="tab1">物流详情</vxe-radio>
          </li>
          <li>
            <vxe-radio name="xtabs" label="tab2">附件关联物流</vxe-radio>
          </li>
          <Button class="btn" type="primary" icon="ios-add" style="margin-left: 10px"
                  v-if="isEdit"
                  :disabled="formData[0].logisticsRelMainOrdersNum && formData[0].logisticsRelMainOrdersNum !== ''"
                  @click="addRelation">新增关联物流
          </Button>
          <Button class="btn" type="primary" style="margin-left: 20px" v-if="selectTab === 'tab2' && isEdit"
                  @click="commitDelete"><i
              class="el-icon-delete" style="margin-right: 10px;"></i>批量删除
          </Button>
        </ul>
      </vxe-radio-group>
    </div>
    <div class="add-box clearfix" v-show="selectTab === 'tab1'">
      <div class="tip-211130">
        <div class="title">订单信息</div>
        <div class="remark" v-if="isHavePermission('logistics2.0:createTime')">创建人：{{formData[0].createUser}}
          <span
              v-if="isHavePermission('logistics2.0:createTime')">| 创建时间：{{formData[0].createTime | timeFormatDate}}</span>
        </div>
      </div>
      <vxe-table
          show-overflow
          ref="xTable"
          class="table-style"
          max-height="400"
          align="center"
          :auto-resize="true"
          :edit-rules="tableRules"
          :data="formData"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column field="logisticsNum" title="物流编号">
          <template v-slot="{ row }">
            <span>{{row.logisticsNum}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ordersNum" title="订单编号">
          <template v-slot="{ row }">
            <span>{{row.ordersNum}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="buyerName" title="托运人名称">
          <template v-slot="{ row }">
            <span>{{row.buyerName}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="compName" title="平台企业">
          <template v-slot="{ row }">
            <span>{{row.compName}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="sellerName" title="承运人名称">
          <template v-slot="{ row }">
            <span>{{row.sellerName}}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="tip-211130">
        <div class="title">货物信息</div>
      </div>
      <vxe-table
          show-overflow
          ref="xTable1"
          class="table-style"
          max-height="400"
          align="center"
          :auto-resize="true"
          :edit-rules="tableRules"
          :data="formData"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column field="goodsType" title="货物类型">
          <template v-slot:header>
            <span style="color: red" v-if="isEdit">*</span>货物类型
          </template>
          <template v-slot="scope">
            <vxe-select v-if="isEdit" v-model="scope.row.goodsType" placeholder="请选择" :options="goodsTypeOptions"
                        @change="clearV"
                        transfer
            ></vxe-select>
            <span v-else>{{scope.row.goodsType}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsName" title="货名">
          <template v-slot:header>
            <span style="color: red" v-if="isEdit">*</span>货名
          </template>
          <template v-slot="scope">
            <vxe-input v-if="isEdit" v-model="scope.row.goodsName" placeholder="必填" @blur="clearV"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
            <span v-else>{{scope.row.goodsName}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsUnit" title="单位">
          <template v-slot:header>
            <span style="color: red" v-if="isEdit">*</span>单位
          </template>
          <template v-slot="scope">
            <vxe-select v-if="isEdit" v-model="scope.row.goodsUnit" placeholder="请选择" :options="unitTypeOptions"
                        @change="clearV"
                        transfer></vxe-select>
            <span v-else>{{scope.row.goodsUnit}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="counts" title="装货数量">
          <template v-slot="scope">
            <vxe-input v-if="isEdit" v-model="scope.row.counts" placeholder="选填" @blur="clearV" type="number"
                       @input="$refs.xTable1.updateStatus(scope)"></vxe-input>
            <span v-else>{{scope.row.counts}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="realCount" title="实际数量">
          <template v-slot:header>
            <span style="color: red" v-if="isEdit">*</span>实际数量
          </template>
          <template v-slot="scope">
            <vxe-input v-if="isEdit" v-model="scope.row.realCount" placeholder="必填" @blur="clearV" type="number"
                       @input="$refs.xTable1.updateStatus(scope)"></vxe-input>
            <span v-else>{{scope.row.realCount}}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="tip-211130">
        <div class="title">物流信息</div>
      </div>
      <vxe-table
          show-overflow
          ref="xTable2"
          class="table-style"
          max-height="400"
          align="center"
          :auto-resize="true"
          :edit-rules="tableRules"
          :data="formData"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column field="logisticsCode" title="物流单号">
          <template v-slot="{ row }">
            <vxe-input v-if="isEdit" v-model="row.logisticsCode" placeholder="选填"></vxe-input>
            <span v-else>{{row.logisticsCode}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logisticsState" title="状态">
          <template v-slot="scope">
            <vxe-select v-if="isEdit" v-model="scope.row.logisticsState" transfer placeholder="请选择">
              <vxe-option v-for="(item,index) in isTopTypeOptions" :key="index" :value="item.value"
                          :label="item.label" @change="clearV"></vxe-option>
            </vxe-select>
            <span v-else>{{scope.row.logisticsState | logisticsIsTopStatusMap}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="driverName" title="实际承运人">
          <template v-slot="{ row }">
            <a v-if="isEdit" class="sel-link" @click="openAccount" target="_black"
               style="cursor: pointer;text-align: center;">{{
              row.driverName === null ||
              row.driverName === "" ? "请选择账户" : row.driverName }}</a>
            <span v-else>{{row.driverName}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="contact" title="联系方式">
          <template v-slot="{ row }">
            <vxe-input v-if="isEdit" v-model="row.contact" placeholder="选填"></vxe-input>
            <span v-else>{{row.contact}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="note" title="备注">
          <template v-slot="{ row }">
            <vxe-input v-if="isEdit" v-model="row.note" placeholder="选填"></vxe-input>
            <span v-else>{{row.note}}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-table
          v-show="!isEdit"
          show-overflow
          class="table-style"
          max-height="400"
          align="center"
          :auto-resize="true"
          :edit-rules="tableRules"
          :data="formData"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column field="carShipNum" title="车船号"></vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地"></vxe-table-column>
        <vxe-table-column field="beginTime" title="起运时间">
          <template v-slot="{ row }">
            <span>{{row.beginTime}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endPlace" title="到达地"></vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间">
          <template v-slot="{ row }">
            <span>{{row.endTime}}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-table
          v-show="isEdit"
          show-overflow
          ref="xTable3"
          class="table-style"
          max-height="400"
          align="center"
          :auto-resize="true"
          :edit-rules="tableRules"
          :data="formData"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column field="carShipNum" title="车船号">
          <template v-slot:header>
            <span style="color: red" v-if="isEdit">*</span>车船号
          </template>
          <template v-slot="{ row, $rowIndex }">
            <a class="sel-link" @click="openCarShip({ i: $rowIndex, data: formData })" target="_black"
               style="cursor: pointer;text-align: center;">
              {{row.carShipNum === null || row.carShipNum === "" ? "请选择车船" : row.carShipNum}}
            </a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="province" title="起运地(省)" width="100">
          <template v-slot:header>
            <span style="color: red" v-if="isEdit && formData[0].logisticsType === 1">*</span>起运地(省)
          </template>
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
                v-model="row.province"
                :options="cityData"
                @change="loadCity(row.province, $rowIndex, 1)"
                @blur="clearV"
                :disabled="row.logisticsType !== 1"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="city" title="起运地(市)" width="100">
          <template v-slot:header>
            <span style="color: red" v-if="isEdit && formData[0].logisticsType === 1">*</span>起运地(市)
          </template>
          <template v-slot=" { row, $rowIndex }">
            <vxe-select v-model="row.city" :options="row.cityOptions" :disabled="row.logisticsType !== 1"
                        @change="loadArea(row.province, row.city, $rowIndex, 1)"
                        @blur="clearV" transfer></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="area" title="起运地(区)" width="100">
          <template v-slot:header>
            <span style="color: red" v-if="isEdit && formData[0].logisticsType === 1">*</span>起运地(区)
          </template>
          <template v-slot="{ row }">
            <vxe-select v-model="row.area" :options="row.areaOptions" @blur="clearV" transfer
                        :disabled="row.logisticsType !== 1"></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginPlaceAddress" title="详细地址" width="160">
          <template v-slot:header>
            <span style="color: red" v-if="isEdit">*</span>详细地址
          </template>
          <template v-slot="scope">
            <vxe-input v-model="scope.row.beginPlaceAddress" placeholder="起运地" @blur="clearV"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginTime" title="起运时间">
          <template v-slot:header>
            <span style="color: red" v-if="isEdit">*</span>起运时间
          </template>
          <template v-slot="{ row }">
            <vxe-input v-model="row.beginTime" placeholder="选择日期"
                       :type="row.logisticsType === 2 ? 'date' : 'datetime'"
                       transfer></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endProvince" title="到达地(省)" width="100">
          <template v-slot:header>
            <span style="color: red" v-if="isEdit && formData[0].logisticsType === 1">*</span>到达地(省)
          </template>
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
                v-model="row.endProvince"
                :options="cityData"
                @change="loadCity(row.endProvince, $rowIndex, 2)"
                @blur="clearV"
                :disabled="row.logisticsType !== 1"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endCity" title="到达地(市)" width="100">
          <template v-slot:header>
            <span style="color: red" v-if="isEdit && formData[0].logisticsType === 1">*</span>到达地(市)
          </template>
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
                v-model="row.endCity"
                :options="row.endCityOptions"
                @change="loadArea(row.endProvince, row.endCity, $rowIndex, 2)"
                @blur="clearV"
                :disabled="row.logisticsType !== 1"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endArea" title="到达地(区)" width="100">
          <template v-slot:header>
            <span style="color: red" v-if="isEdit && formData[0].logisticsType === 1">*</span>到达地(区)
          </template>
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.endArea"
                :options="row.endAreaOptions"
                @blur="clearV"
                :disabled="row.logisticsType !== 1"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endPlaceAddress" title="详细地址" width="160">
          <template v-slot:header>
            <span style="color: red" v-if="isEdit">*</span>详细地址
          </template>
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.endPlaceAddress"
                placeholder="到达地"
                @focus="clearV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间">
          <template v-slot:header>
            <span style="color: red" v-if="isEdit">*</span>到达时间
          </template>
          <template v-slot="{ row }">
            <vxe-input v-model="row.endTime" placeholder="选择日期"
                       :type="row.logisticsType === 2 ? 'date' : 'datetime'"
                       transfer></vxe-input>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-table
          show-overflow
          :auto-resize="true"
          class="table-upload-style"
          max-height="160"
          :data="formData"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column field="logisticsFiles" title="附件">
          <template v-slot="{ row }">
            <upload-list
                :isEdit="isEdit"
                :row="row"
                :initFileList="logisticsFiles"
                :view="'arrange'"
                :maxLength="10"
            ></upload-list>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logisticsRelFiles" title="关联附件">
          <template v-slot:header>
            <span>关联附件{{formData[0].logisticsRelMainOrdersNum ? '（关联订单编号：'+formData[0].logisticsRelMainOrdersNum+'）' : '' }}</span>
            <Button type="primary" style="margin-left: 20px;width: 110px;height: 28px;border-radius: 4px;" v-if="isEdit"
                    @click="cancelRel"><i class="el-icon-link" style="margin-right: 10px;"></i>取消关联
            </Button>
          </template>
          <template v-slot="{ row }">
            <upload-list
                :isEdit="false"
                :row="row"
                :initFileList="logisticsRelFiles"
                :view="'arrange'"
            ></upload-list>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div v-show="selectTab === 'tab2'">
      <div class="list-box common-shadow clearfix">
        <vxe-table
            class="table-style"
            highlight-hover-row
            show-footer
            stripe
            ref="xGrid"
            align="center"
            border="none"
            max-height="600"
            :data="relData"
            :loading="loading"
            :auto-resize="true"
            @sort-change="sortChangeEvent"
            @filter-change="filterChangeMethod"
            @checkbox-all="selectAllEvent"
            @checkbox-change="selectChangeEvent"
        >
          <vxe-table-column type="checkbox" align="center" width="50" v-if="isEdit"></vxe-table-column>
          <vxe-table-column field="ordersNum" title="订单编号" width="140"></vxe-table-column>
          <vxe-table-column field="goodsName" title="货物名称" width="105" show-overflow></vxe-table-column>
          <vxe-table-column field="goodsUnit" title="单位" width="60" show-overflow></vxe-table-column>
          <vxe-table-column field="realCount" title="实际数量" width="90" show-overflow></vxe-table-column>
          <vxe-table-column field="carShipNum" title="车船号" width="140" show-overflow></vxe-table-column>
          <vxe-table-column field="beginPlace" title="起运地" width="200" show-overflow></vxe-table-column>
          <vxe-table-column field="endPlace" title="目的地" width="200" show-overflow></vxe-table-column>
          <vxe-table-column field="beginTime" title="起运时间" width="140" remote-sort>
            <template slot-scope="{ row }">
              <span style="color: #a7adad">{{ row.beginTime | timeFormatDate}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="endTime" title="到达时间" width="140" remote-sort>
            <template slot-scope="{ row }">
              <span style="color: #a7adad">{{ row.endTime | timeFormatDate}}</span>
            </template>
          </vxe-table-column>
        </vxe-table>
        <vxe-pager
            background
            size="small"
            :current-page.sync="page.currentPage"
            :page-size.sync="page.pageSize"
            :total="page.totalResult"
            @page-change="changePage"
        ></vxe-pager>
      </div>
    </div>
    <div class="modal-footer add-btn-box" style="width: 98%;position: absolute;bottom: 0;padding:10px !important;">
      <Button type="primary" v-if="isEdit" @click="update">保 存</Button>
      <Button type="primary" v-if="!isEdit && isHavePermission('logistics2.0:update')" @click="goUpdate">编 辑</Button>
    </div>
    <vxe-modal v-model="relationVisible" title="新增关联物流" width="1300" height="650" resize position="center"
               @close="closeRelation">
      <relation-logistics ref="relationLogistics" @afterSave="afterSave"></relation-logistics>
    </vxe-modal>
    <vxe-modal v-model="accountVisible" title="选择账户" width="700" height="600" @close="closeAccount" resize
               position="center">
      <choose-driver @choose="chooseAccount" ref="accountModel"></choose-driver>
    </vxe-modal>
    <vxe-modal v-model="carShipVisible" title="选择车船" width="1300" height="600" resize position="center">
      <choose-car-ship ref="carShipModal" @choose="chooseCarShip"></choose-car-ship>
    </vxe-modal>
  </div>
</template>
<script>
  import $api from "@/apiProvider";
  import $C from "@/consts";
  import ChooseDriver from "@/components/modal/ChooseDriver";
  import ChooseCarShip from "@/components/modal/ChooseCarShip";
  import UploadList from "@/components/common/UploadList";
  import RelationLogistics from "@/components/order2.0/Logistics/RelationLogistics";
  import {hideLoading, isEmpty, isNotEmpty, showLoading} from "@/utils/util";
  import getAuthOrization from "@/mixin/getAuthOrization";

  let appData = require("@/assets/json/zz.json");

  export default {
    name: "LogisticsDetail",
    components: {ChooseDriver, ChooseCarShip, RelationLogistics, UploadList},
    mixins: [getAuthOrization],
    data() {
      return {
        selectTab: "tab1",
        formData: [{
          fileUuidList: [],
          secSellerName: null,
          carShipNum: null
        }],
        tableRules: {
          goodsName: [{required: true, message: "请输入货名"}],
          goodsType: [{required: true, message: "请选择货物类型"}],
          goodsUnit: [{required: true, message: "请选择单位"}],
          carShipNum: [{required: true, message: "请选择车船号"}],
          realCount: [{required: true, message: "请输入实际数量"}],
          province: [{validator: this.requireValid}],
          city: [{validator: this.requireValid}],
          area: [{validator: this.requireValid}],
          endProvince: [{validator: this.requireValid}],
          endCity: [{validator: this.requireValid}],
          endArea: [{validator: this.requireValid}],
          beginPlaceAddress: [{required: true, message: "请输入起运地详细地址"}],
          endPlaceAddress: [{required: true, message: "请输入到达地详细地址"}],
          beginTime: [{required: true, message: "请选择起运时间"}],
          endTime: [{required: true, message: "请选择到达时间"}],
        },
        goodsTypeOptions: [],
        unitTypeOptions: [],
        isTopTypeOptions: $C.LogisticsIsTopStatus.options,
        accountVisible: false,
        carShipVisible: false,
        relData: [],
        loading: false,
        relationVisible: false,
        logisticsFiles: [],
        logisticsRelFiles: [],
        isEdit: false,
        cityData: [],
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100
        },
        records: []
      }
    },
    mounted() {
      this.getDicDate();
    },
    methods: {
      closeDetail() {
        this.logisticsFiles = [];
        this.logisticsRelFiles = [];
        this.selectTab = "tab1";
        this.records = [];
      },
      closeRelation() {
        this.$refs.relationLogistics.close();
      },
      async requireValid(e) {
        if (
          e.row.logisticsType === 1 && e.column.title === "起运地(省)" && isEmpty(e.row.province)
        ) {
          return Promise.reject(new Error("请选择起运地省"));
        }
        if (
          e.row.logisticsType === 1 && e.column.title === "起运地(市)" && isEmpty(e.row.city)
        ) {
          return Promise.reject(new Error("请选择起运地市"));
        }
        if (
          e.row.logisticsType === 1 && e.column.title === "起运地(区)" && isEmpty(e.row.area)
        ) {
          return Promise.reject(new Error("请选择起运地区"));
        }
        if (
          e.row.logisticsType === 1 && e.column.title === "到达地(省)" && isEmpty(e.row.endProvince)
        ) {
          return Promise.reject(new Error("请选择到达地省"));
        }
        if (
          e.row.logisticsType === 1 && e.column.title === "到达地(市)" && isEmpty(e.row.endCity)
        ) {
          return Promise.reject(new Error("请选择到达地市"));
        }
        if (
          e.row.logisticsType === 1 && e.column.title === "到达地(区)" && isEmpty(e.row.endArea)
        ) {
          return Promise.reject(new Error("请选择到达地区"));
        }
      },
      goUpdate() {
        this.isEdit = true;
        this.$emit('update');
      },
      cancelRel() {
        this.$XModal.confirm("您确定要取消关联吗？").then((type) => {
          if (type === "confirm") {
            this.unbindMainOrders();
          }
        });
      },
      async unbindMainOrders() {
        let res = await $api.logisticsTwo.post('rel/unbindMainOrders', {
          id: this.id,
        });
        if (res.status === 1) {
          this.$Message.success("取消成功");
          this.page.currentPage = 1;
          this.detail();
          this.list();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      showUpdate(id) {
        this.id = id;
        this.isEdit = true;
        this.detail();
        this.list();
      },
      showDetail(id) {
        this.id = id;
        this.isEdit = false;
        this.detail();
        this.list();
      },
      async detail() {
        this.logisticsFiles = [];
        this.logisticsRelFiles = [];
        let res = await $api.logisticsTwo.post('logistics/detail', {
          id: this.id,
        });
        if (res.status === 1) {
          let data = res.data;
          if (data.logisticsType === 1) {
            data.beginTime = this.$utils.toDateString(data.beginTime, "yyyy-MM-dd HH:mm:ss");
            data.endTime = this.$utils.toDateString(data.endTime, "yyyy-MM-dd HH:mm:ss");
          } else {
            data.beginTime = this.$utils.toDateString(data.beginTime, "yyyy-MM-dd");
            data.endTime = this.$utils.toDateString(data.endTime, "yyyy-MM-dd");
          }
          data.province = data.beginPlacePro;
          data.city = data.beginPlaceCity;
          data.area = data.beginPlaceArea;
          data.endProvince = data.endPlacePro;
          data.endCity = data.endPlaceCity;
          data.endArea = data.endPlaceArea;
          data.fileUuidList = [];

          this.formData = [];
          this.formData.push(data);

          if (data.logisticsFiles && data.logisticsFiles.length > 0) {
            data.logisticsFiles.map(i => {
              this.logisticsFiles.push(i);
              this.formData[0].fileUuidList.push(i.uuid);
            })
          }
          if (data.logisticsRelFiles && data.logisticsRelFiles.length > 0) {
            data.logisticsRelFiles.map(i => {
              this.logisticsRelFiles.push(i);
            })
          }


        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async list() {
        this.loading = true;
        let res = await $api.logisticsTwo.post('rel/list', {
          id: this.id,
          page: this.page.currentPage,
          rows: this.page.pageSize,
        });
        this.loading = false;
        if (res.status === 1) {
          this.page.totalResult = res.data.total;
          this.relData = res.data.rows;
          this.relData.map((i) => {
            this.records.map((j) => {
              if (i.id === j.id) {
                this.$refs.xGrid.setCheckboxRow(i, true);
              }
            });
          });
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      changePage(e) {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.list();
      },
      async validEvent() {
        let errMap = await this.$refs.xTable1
          .validate()
          .catch((errMap) => errMap);
        if (!errMap) {
          errMap = await this.$refs.xTable3.validate().catch((errMap) => errMap);
        }
        return errMap ? false : true;
      },
      async update() {
        let sts = await this.validEvent();
        if (!sts) {
          this.$XModal.message({status: "error", message: "校验不通过！"});
          return;
        }
        let arr = JSON.parse(JSON.stringify(this.formData));
        let isTrue = true;
        arr.map(i => {
          if (i.endTime !== null && i.endTime !== "") {
            if (i.beginTime > i.endTime) {
              this.$XModal.alert({
                message: '到达时间不能早于到达时间',
                status: "error",
              });
              isTrue = false;
            }

          }
          if (!isTrue) return;
          i.beginTime = this.$utils.timestamp(i.beginTime);
          if (i.endTime) {
            i.endTime = this.$utils.timestamp(i.endTime);
          }

          if (i.logisticsType === 1) {
            i.beginPlacePro = i.province;
            i.beginPlaceCity = i.city;
            i.beginPlaceArea = i.area;

            i.endPlacePro = i.endProvince;
            i.endPlaceCity = i.endCity;
            i.endPlaceArea = i.endArea;
          }
        })

        showLoading();
        let res = await $api.logisticsTwo.post("logistics/update", arr[0]);
        hideLoading();
        if (res.status === 1) {
          this.$Message.success("修改成功");
          this.closeDetail();
          this.$emit('afterSave');
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      commitDelete() {
        if (this.records.length === 0) {
          this.$XModal.alert({
            message: '请选择关联物流',
            status: "error",
          });
          return
        } else {
          this.removeSubOrderIds();
        }
      },
      async removeSubOrderIds() {
        let idList = [];
        this.records.map(i => {
          idList.push(i.id);
        })
        let res = await $api.logisticsTwo.post('rel/removeSubOrderIds', {
          ordersId: this.id,
          relIdList: idList
        });
        if (res.status === 1) {
          this.$Message.success("删除成功");
          this.records = [];
          this.page.currentPage = 1;
          this.detail();
          this.list();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      addRelation() {
        this.relationVisible = true;
        this.$refs.relationLogistics.init(this.id);
      },
      afterSave() {
        this.relationVisible = false;
        this.detail();
        this.list();
      },
      sortChangeEvent(sort) {

      },
      filterChangeMethod({values}) {

      },
      selectChangeEvent({checked, row}) {
        if (checked) {
          this.records.push(row);
        } else {
          let key = this.records.indexOf(row);
          this.records.splice(key, 1);
        }
      },
      selectAllEvent({checked, records}) {
        if (checked) {
          this.records = records;
        } else {
          this.records = [];
        }
      },
      openCarShip(obj) {
        this.info = obj;
        this.carShipVisible = true;
        this.$refs.carShipModal.init();
      },
      chooseCarShip(row, type) {
        let data = this.info.data;
        let i = this.info.i;
        if (type === "ship") {
          data[i].carShipNum = row.shipName;
          data[i].carShipId = row.id;
          data[i].mmsi = row.mmsi;
          data[i].logisticsType = 2;
        } else {
          data[i].carShipNum = row.carNum;
          data[i].carShipId = row.id;
          data[i].logisticsType = 1;
        }
        this.$refs.carShipModal.close();
        this.carShipVisible = false;
        this.clearV();
      },
      loadCity(province, index, type, isImpot = false) {
        let tableData = this.$refs.xTable3.getTableData().tableData;
        if (!isImpot) {
          if (type === 1) {
            tableData[index].city = "";
            tableData[index].area = "";
          } else {
            tableData[index].endCity = "";
            tableData[index].endArea = "";
          }
        }

        let cityOptions = appData.filter(i => i.label === province);
        // console.log(appData, province, cityOptions, 'cityOptions');

        let isHasChildren = cityOptions[0].children.some(m =>
          isNotEmpty(m.children)
        );
        if (isHasChildren) {
          let arr = cityOptions[0].children.map(i => {
            return {
              label: i.label,
              value: i.label
            };
          });
          type === 1
            ? (tableData[index].cityOptions = arr)
            : (tableData[index].endCityOptions = arr);
        } else {
          let cityArr = [
            {
              label: province,
              value: province
            }
          ];
          type === 1
            ? (tableData[index].cityOptions = cityArr)
            : (tableData[index].endCityOptions = cityArr);
        }
      },
      loadArea(province, city, index, type, isImpot = false) {
        let tableData = this.$refs.xTable3.getTableData().tableData;
        if (!isImpot) {
          if (type === 1) {
            tableData[index].area = "";
          } else {
            tableData[index].endArea = "";
          }
        }
        let cityOptions = appData.filter(i => i.label === province);
        let arr = [];
        if (province === city) {
          arr = cityOptions[0].children.map(i => {
            return {
              label: i.label,
              value: i.label
            };
          });
        } else {
          let areaOptions = cityOptions[0].children.filter(i => i.label === city);
          arr = areaOptions[0].children.map(i => {
            return {
              label: i.label,
              value: i.label
            };
          });
        }
        type === 1
          ? (tableData[index].areaOptions = arr)
          : (tableData[index].endAreaOptions = arr);
      },
      loadData(item, callback) {
        const getTree = jsonObj => {
          function toParse(jsonObj) {
            jsonObj.forEach(item => {
              item.value = item.label;
              if (item.children && Array.isArray(item.children)) {
                toParse(item.children);
              }
            });
            return jsonObj;
          }

          return toParse(jsonObj);
        };
        let curCityData = getTree(appData);
        item.loading = true;
        setTimeout(() => {
          let arr = curCityData.filter(i => {
            return i.label === item.value;
          });
          item.children = arr[0].children;
          item.loading = false;
          callback();
        }, 1000);
      },
      changeTab() {

      },
      getDicDate() {
        this.goodsTypeOptions = [];
        this.unitTypeOptions = [];
        $api.other.getGoodsTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100
            }
          })
          .then(res => {
            res.data.map(item => {
              let obj = {
                label: item.dictText,
                value: item.dictText
              };
              this.goodsTypeOptions.push(obj);
            });
          });
        $api.other.getUnitTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100
            }
          })
          .then(res => {
            res.data.map(item => {
              let obj = {
                label: item.dictText,
                value: item.dictText
              };
              this.unitTypeOptions.push(obj);
            });
          });

        appData.forEach(item => {
          let obj = {
            value: item.label,
            label: item.label
            // children: [],
            // loading: false
          };
          this.cityData.push(obj);
        });
      },
      clearV() {
        this.$refs.xTable1.clearValidate();
        this.$refs.xTable2.clearValidate();
        this.$refs.xTable3.clearValidate();
      },
      //打开选择弹窗
      openAccount() {
        this.accountVisible = true;
        this.$refs.accountModel.init(this.formData[0].logisticsType);
      },
      //选择后回调填入数据
      chooseAccount(row) {
        this.formData[0].driverName = row.realName;
        this.formData[0].driverId = row.id;
        this.formData[0].contact = row.phoneNum;
        this.accountVisible = false;
        this.$refs.accountModel.close();
      },
      closeAccount() {
        this.accountVisible = false;
        this.$refs.accountModel.close();
      },
    }
  }
</script>
<style scoped>
  .tip {
    box-sizing: border-box;
    padding: 20px 0 20px 0;
    display: flex;
    align-items: center;
  }

  /* .title {
    font-size: 16px;
    font-family: Microsoft YaHei, sans-serif;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
  } */

  .remark {
    margin-left: auto;
    font-size: 14px;
    font-family: Microsoft YaHei, sans-serif;
    font-weight: 400;
    color: #8C929F;
  }

  .btn {
    height: 28px;
    /*background: #2D8CF0;*/
    border-radius: 4px;
  }
</style>